export const isLeapYear = (year: string) => {
  const yearInt = parseInt(year, 10)
  if (yearInt % 4 !== 0) {
    return false
  }
  if (yearInt % 400 === 0) {
    return true
  }
  if (yearInt % 100 === 0) {
    return false
  }
  return true
}

export const getBirthdayIsoString = (birthdayDay: string, birthdayMonth: string, birthdayYear: string): string => {
  const date = new Date()

  date.setDate(parseInt(birthdayDay, 10))
  date.setMonth(parseInt(birthdayMonth, 10))
  date.setFullYear(parseInt(birthdayYear, 10))

  return date.toISOString()
}

export const getLocalDateIsoString = (selectedDateIsoString?: string) => {
  // get the selected date timestamp otherwise use the current timestamp
  const selectedDateTimestamp = selectedDateIsoString ? new Date(selectedDateIsoString).getTime() : Date.now()

  const internalOffset = selectedDateTimestamp - new Date().getTimezoneOffset() * 60000

  const newDateObject = new Date(internalOffset)

  return newDateObject.toISOString()
}
